export default "__VITE_ASSET__Bwaib$Op__"